import { render, staticRenderFns } from "./InputBase.vue?vue&type=template&id=2596acc2&scoped=true&"
import script from "./InputBase.vue?vue&type=script&lang=js&"
export * from "./InputBase.vue?vue&type=script&lang=js&"
import style0 from "./InputBase.vue?vue&type=style&index=0&id=2596acc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596acc2",
  null
  
)

export default component.exports